// extracted by mini-css-extract-plugin
module.exports = {"notice":"notice-4be","noticeWrapper":"notice__wrapper-66b","noticeTurquoise":"notice_turquoise-1fb"};